<script setup>
const { applicationId } = defineProps({
  applicationId: String,
});

const emits = defineEmits(["onClose"]);

const toast = useToast();
const comment = ref("");

const handleRevise = async () => {
  await useApiFetch(`student-applications/${applicationId}/documents/revise`, {
    method: "POST",
    body: {
      revise_comment: comment.value,
    },
    onResponse() {
      refreshNuxtData("student-application-detail");
      emits("onClose");
      toast.add({
        severity: "success",
        summary: "Requested to revise document.",
        life: 3000,
      });
    },
  });
};
</script>

<template>
  <div class="px-8 py-5">
    <h2 class="font-semibold text-xl text-primary-500 mb-5">
      Document Revision Reason
    </h2>
    <p class="text-sm text-muted mb-3">
      Please clearly explain what is wrong with the document and what the
      student mentor needs to do to fix it.
    </p>
    <Textarea
      v-model="comment"
      :rows="4"
      placeholder="Add a comment"
      fluid
      class="w-full"
    ></Textarea>
  </div>
  <div class="px-8 py-5 space-x-3 text-right">
    <Button outlined @click="emits('onClose')" size="small">Cancel</Button>
    <Button @click="handleRevise" size="small" :disabled="comment === ''"
      >Send</Button
    >
  </div>
</template>
